export default __webpack_public_path__ + "/dist/images/406673.4f2f78133dbd72c666a43ed3aac48a05.png";